/** Organisation setting: user-facing label for project folders */
export const PROJECT_NOMENCLATURE = {
  PROJECT: 'project',
  PROGRAM: 'program',
}

export function getProjectNomenclature(org) {
  if (!org || org.id === 0) return PROJECT_NOMENCLATURE.PROJECT
  return org.projectNomenclature || PROJECT_NOMENCLATURE.PROJECT
}

export function usesProgramTerminology(org) {
  return getProjectNomenclature(org) === PROJECT_NOMENCLATURE.PROGRAM
}

export function getProjectTerms(org) {
  const isProgram = usesProgramTerminology(org)
  const singular = isProgram ? 'Program' : 'Project'
  const plural = isProgram ? 'Programs' : 'Projects'
  const lowerSingular = singular.toLowerCase()
  const lowerPlural = plural.toLowerCase()

  return {
    singular,
    plural,
    lowerSingular,
    lowerPlural,
    managerRoleLabel: `${singular} manager`,
    accessTitle: `${singular} access`,
    allPluralHint: `All ${lowerPlural}`,
    sitesInContainer: `All sites in this ${lowerSingular}`,
    noSitesInContainer: `No sites in this ${lowerSingular} yet.`,
    notAddedYet: `You haven't been added to a ${lowerSingular} yet.`,
    notAddedToSiteInContainer: `You haven't been added to a site in this ${lowerSingular} yet.`,
    loadingPlural: `Loading ${lowerPlural}...`,
    noInOrganisation: `No ${lowerPlural} in this organisation yet.`,
    failedAccessLoad: `Failed to load ${lowerSingular} access.`,
    inviteOrgMemberDescription:
      'Enter email addresses and select a role. Use Member for users who should only access assigned ' +
      `${lowerPlural}.`,
    inviteProjectMemberDescription:
      'Select organisation members below or enter email addresses, then choose a ' +
      `${lowerSingular} role.`,
    inviteSiteOnlySuffix: `They will not get access to other sites in the ${lowerSingular} unless added separately.`,
    implicitAccessInviteHint: `Organisation admins and managers already have access to all ${lowerPlural}.`,
    addMemberFailed: `Failed to add ${lowerSingular} member. Please try again.`,
    nomenclatureOptions: [
      { label: 'Project — default Forge terminology', value: PROJECT_NOMENCLATURE.PROJECT },
      { label: 'Program — for cohorts, courses, and initiatives', value: PROJECT_NOMENCLATURE.PROGRAM },
    ],
  }
}
